export default {
  presenter: 'ziegler',
  title: 'Síťové simulátory letem světem',
  subtitle: 'začátečníci',
  text: `
Letmý přehled a porovnání nejen open-source síťových simulátorů. Aneb jak bez potřebného
hardwaru a kabelů navrhovat a testovat funkčnost datové sítě.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/ziegler-sitove-simulatory.js